import { render, staticRenderFns } from "./commentThread.vue?vue&type=template&id=e00d4066&scoped=true&"
import script from "./commentThread.vue?vue&type=script&lang=js&"
export * from "./commentThread.vue?vue&type=script&lang=js&"
import style0 from "./commentThread.vue?vue&type=style&index=0&id=e00d4066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00d4066",
  null
  
)

export default component.exports